import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/item-catalog/*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const itemCatalogRoute = defineRoute("/libraries/item-catalog");
export const bidItemCreateRoute = defineRoute("/libraries/item-catalog/add");
export const bidItemDetailsRoute = defineRoute("/libraries/item-catalog/:bidItemId");
